import React from 'react';
import './App.css';
import TestForm from './TestForm';

function App() {
  return (
    <div className="App" >
    <TestForm />
    </div>
  );
}

export default App;
